import { getAxiosClient } from '../http.client';
export class FluidAdminClient {
    apiClient;
    async client() {
        if (this.apiClient) {
            return this.apiClient;
        }
        this.apiClient = getAxiosClient('admin/fluid-admin');
        return this.apiClient;
    }
    async getCompanyStats() {
        const client = await this.client();
        const response = await client.get('/');
        return response.data;
    }
    async getWeeklyStats(orgId) {
        const client = await this.client();
        const params = orgId ? { orgId } : {};
        const response = await client.get('/weekly-stats', { params });
        return response.data;
    }
}
